module.exports = __webpack_public_path__ + "img/yishi19.2f3e12a2.jpg";